/*
 * @Author: ningbo.kang
 * @Date: 2019-10-23 17:56:58
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-11-01 14:53:50
 * @FilePath: /template/src/router/asyncRouter.js
 * @Description: 路由与权限过滤
 */

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  // if (process.env.VUE_APP_PREVIEW === 'true') {
  //   return true;
  // }
  if (route.meta && route.meta.perms) {
    const tempPerm = [];
    // 修正数据,检查路由中每个权限值是否在权限数组中存在，若存在则放入临时数据
    // 策略1，permission 是过滤后权限，
    // route.meta.perms.forEach((item) => {
    //   if (permission.includes(item)) {
    //     tempPerm.push(item);
    //   }
    // });

    // 策略2
    // meta.perms 第一个元素作为页面权限值，如果权限页面没找到，则整个页面停止搜索
    const { perms } = route.meta;
    for (let index = 0; index < perms.length; index += 1) {
      // 如果是第一个且为空，则认为有权限
      if (index === 0) {
        // 如果第一项是空，则认为页面不需要权限
        if (perms[index] === '') {
          tempPerm.push(perms[index]);
        } else {
          // 如果页面配置了权限key
          const flag = permission.includes(perms[index]);
          if (flag) {
            tempPerm.push(perms[index]);
          } else {
            // 页面无权限，则直接跳出循环
            break;
          }
        }
      } else {
        // 是否匹配到
        const flag = permission.includes(perms[index]);
        // 第一个且没有找到，则跳出查找
        if (flag) {
          tempPerm.push(perms[index]);
        }
      }
    }
    // 策略 end

    // 使用处理过数据覆盖掉，根据长度判断是否有权限
    route.meta.perms = tempPerm;
    if (tempPerm.length) {
      return true;
    }
    return false;
  }
  // 如果没有配置 meta.perms,则默认不做校验
  return true;
}

/**
 * 过滤动态路由，返回可以访问页面路由
 * 递归
 * @param {*} routerMap
 * @param {*} roles
 */
function filterAsyncRouter(routerMap, roles) {
  const accessedRouters = routerMap.filter((route) => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    }
    return false;
  });
  // console.log('filter router', accessedRouters);
  return accessedRouters;
}

// const aaaaa = filterAsyncRouter(asyncRouterMap, ['page.about', 'b', 'c', 'd', 'e']);

export default filterAsyncRouter;
